'use client'
import {CSSProperties, ReactNode} from "react";
import {TextSize} from "@web-libs/ui/ui-components/typo/types";
import {Color, getCssVar} from "@web-libs/features/colors/application/colors";
import cssStyles from './text.module.css';
import {mergeClassNames} from "@web-libs/util/class-names/class-names";

export type TextProps = {
    children: ReactNode,
    size?: TextSize
    style?: CSSProperties
    className?: string
    block?: boolean,
    color?: Color
    bold?: boolean,
    italic?: boolean
}

const ClassTable: {[key in TextSize] : string} = {
    xs: cssStyles.xs,
    sm: cssStyles.sm,
    md: cssStyles.md,
    lg: cssStyles.lg
}

export const Text = ({children, style, size="sm", color, className, block=false, bold=false, italic=false}: TextProps) => {

    const textColor = color ? getCssVar(color) : "inherit"

    const _style = {
        color: textColor,
        ...style
    }

    const sizeClass = ClassTable[size]

    if(bold) {
        _style.fontWeight = "bold"
    }

    if(italic) {
        _style.fontStyle = "italic"
    }

    if(block) {
        _style.display = "block"
    }

    return (
        <span style={_style} className={mergeClassNames(className, sizeClass, cssStyles.textClass)}>
            {children}
        </span>
    )
}
